import { all } from "redux-saga/effects";
import loginSaga from "./auth/saga";
import userSaga from "./user/saga";
import transactionSaga from "./transactions/saga";
import complaintSaga from "./complaints/saga";
import simplSaga from "./simpl/saga";
import serviceSaga from "./service/saga";
import incentiveSaga from "./incentive/saga";
import clientSaga from "./client_credential/saga";
import CommunicationchannelSaga from "./communication_channel/saga";
import cphSaga from "./customer_payment_history/saga";
import billerSaga from "./billers/saga";

// import customerParametersSaga from './customer_parameters/saga'
import getReconSaga from "./ReconAndSettlement/saga";
import AddAgentSaga from "./AddAgent/saga";
import CreateCrdential from "./CreateCredential/saga";
import AgentDataSaga from "./Agent/saga";
import createAiCredentialSaga from "./createAiCredential/saga";
import dashboardLoggerSaga from "./dashboardLogger/saga";

export default function* rootSaga() {
  yield all([
    loginSaga(),
    userSaga(),
    transactionSaga(),
    complaintSaga(),
    simplSaga(),
    cphSaga(),
    serviceSaga(),
    incentiveSaga(),
    clientSaga(),
    CommunicationchannelSaga(),
    getReconSaga(),
    AddAgentSaga(),
    CreateCrdential(),
    AgentDataSaga(),
    createAiCredentialSaga(),
    billerSaga(),
    dashboardLoggerSaga(),
  ]);
}
